"use client";

import React from 'react';

export const CookiePreferencesLink = () => {
  const openModal = () => {
    window.dispatchEvent(new CustomEvent("openPrivacyModal"));
  };

  return (
    <button
      onClick={openModal}
      className="hover:text-primary-foreground transition-colors focus-bloom rounded text-[11px] font-sans text-primary-foreground/85 uppercase tracking-[0.2em]"
      aria-label="Open cookie preferences"
    >
      Cookie Preferences
    </button>
  );
};
